import { isValidPhoneNumber } from '@shared/utils/contact-helper';
import z from 'zod';

export const PreferredContactSchema = z
  .object({
    email: z
      .string()
      .trim()
      .toLowerCase()
      .refine((value) => value === '' || z.string().email().safeParse(value).success, {
        message: 'Invalid email address',
      }),
    messagingType: z.string().trim(),
    phoneCall: z
      .string()
      .trim()
      .refine((val) => val === '' || isValidPhoneNumber(val), {
        message: 'Invalid phone number',
      }),

    messaging: z
      .string()
      .trim()
      .refine((val) => val === '' || isValidPhoneNumber(val), {
        message: 'Invalid phone number',
      }),
    emailEnabled: z.boolean(),
    messagingEnabled: z.boolean(),
    phoneCallEnabled: z.boolean(),
    contactMethods: z.boolean().optional(),
    timeRange: z.tuple([z.string(), z.string()]).nullable(),
  })
  .superRefine((data, ctx) => {
    const anySelected = data.emailEnabled || data.messagingEnabled || data.phoneCallEnabled;

    if (!anySelected) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please select at least one contact method.',
        path: ['contactMethods'],
      });
    }

    if (data.emailEnabled && !data.email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Email is required.',
        path: ['email'],
      });
    }

    if (data.messagingEnabled) {
      if (!data.messaging) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Messaging number is required.',
          path: ['messaging'],
        });
      }
    }

    if (data.phoneCallEnabled && !data.phoneCall) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Phone number is required.',
        path: ['phoneCall'],
      });
    }

    if (anySelected && (!data.timeRange || !data.timeRange[0] || !data.timeRange[1])) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please select a time range.',
        path: ['timeRange'],
      });
    }
  });
